import {useFocusEffect} from '@react-navigation/native';
import {useDispatch} from 'Provider';
import {useCallback} from 'react';

import {ReservationsActions} from 'store/reservations/reservations.reducer';

export const useGetReservations = () => {
  const dispatch = useDispatch();

  const handleGetReservationsQuery = useCallback(() => {
    dispatch(ReservationsActions.getReservations());
  }, [dispatch]);

  const handleFocused = useCallback(() => {
    setTimeout(() => {
      handleGetReservationsQuery();
    }, 10);
  }, [handleGetReservationsQuery]);

  return useFocusEffect(handleFocused);
};
